import styled from 'styled-components';
import { AntInput } from 'uiKits/Input';

export const BodyWrapper = styled.div`
  padding: 0 30px;
`;

export const StyledInput = styled(AntInput)``;
